import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import Config from '../constants/Config';
import TourProperty from '../models/TourProperty';

export function getProperties(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_PROPERTY_LIST,
        params: params,
        parser: propertyDataParser,
    }).get();
}

export function getAllProperties(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_PROPERTY_LIST_ALL,
        params: params,
        parser: propertyAllDataParser,
    }).get();
}

export function getPropertyDetail(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_PROPERTY_DETAIL,
        endpointParams: { id },
        parser: data => new TourProperty(data.data),
    }).get();
}

export function createProperty(property) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_PROPERTY_CREATE,
    }).post(property.export());
}

export function updateProperty(property) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_PROPERTY_UPDATE,
    }).put(property.export());
}

export function deleteProperty(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_PROPERTY_DELETE,
        endpointParams: { id },
    }).delete();
}

export function createPropertyTranslate(property) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_PROPERTY_TRANSLATE_CREATE,
    }).post(property.export(true).translate());
}

export function updatePropertyTranslate(property) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_PROPERTY_TRANSLATE_UPDATE,
    }).put(property.export(true).translate());
}

export function deletePropertyTranslate(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_PROPERTY_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}


function propertyDataParser(data = {}) {
    return {
        ...data.data,
        result: (data.data.result || []).map(item => new TourProperty(item))
    }
}

function propertyAllDataParser(data = {}) {
    return (data.data || []).map(item => new TourProperty(item))
}